import { useState, useRef, useEffect } from 'react';
import Button from '@deprecated-ui/common/Button';
import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import Image from 'global/Image';
import If from 'global/Common/If';
import IconRadioSelect from 'assets/customIcon/IconRadioSelect';
import CloseSvg from 'global/Icons/CloseSvg';
import { useSelector } from 'react-redux';
import { selectors as profileSelector } from 'lib/entities/profile';
import { ModalOptionOTP, OptionOTP, OptionOTPText } from './styled';
import CountDown, { CountdownRef } from './SectionOTPCountdown';
import { CHANNEL_OTP } from './config';
import { maskEmail, maskPhoneNumber } from './utils';

interface ModalOTPOptions {
  visible: boolean;
  closeModal: () => void;
  initalSecond: number;
  selectedOption: string;
  otpOptions?: {
    value: CHANNEL_OTP;
    icon: string;
    text: string;
    subText: string;
  }[];
  setSelectedOption: (v: string) => void;
  resetCountDown: () => void;
  onRequestOTP: () => Promise<void>;
}

const ModalOTPOptions = ({
  visible = false,
  closeModal,
  initalSecond = 10,
  selectedOption = '',
  otpOptions,
  setSelectedOption,
  resetCountDown,
  onRequestOTP,
}: ModalOTPOptions) => {
  const countdownRef = useRef<CountdownRef>(null);
  const [optionAvailable, setOptionAvailable] = useState(false);
  const { data } = useSelector(profileSelector);

  useEffect(() => {
    setOptionAvailable(initalSecond === 0);
  }, [initalSecond]);

  const options = [
    {
      value: CHANNEL_OTP.EMAIL,
      icon: '/icon/password-email-small.svg',
      text: 'Send via Email',
      subText: maskEmail(data?.email),
    },
    {
      value: CHANNEL_OTP.WHATSAPP,
      icon: '/icon/password-whatsapp.svg',
      text: 'Send via Whatsapp',
      subText: maskPhoneNumber(data?.phone),
    },
    {
      value: CHANNEL_OTP.SMS,
      icon: '/icon/password-message.svg',
      text: 'Send via SMS',
      subText: maskPhoneNumber(data?.phone),
    },
  ];

  const optionsToRender = otpOptions ?? options;

  return (
    <ModalOptionOTP
      title="Choose Verification Code Method"
      visible={visible}
      centered
      width="480px"
      closeIcon={<CloseSvg width="10px" height="10px" strokeWidth="2" />}
      onCancel={closeModal}
    >
      <If condition={optionAvailable}>
        {/* @ts-expect-error */}
        <Text pb="12px">
          Verification code will be sent via the chosen method:
        </Text>
      </If>
      <If condition={!optionAvailable}>
        {/* @ts-expect-error */}
        <Text pb="12px">
          Send new verification code in{' '}
          <b>
            <CountDown
              ref={countdownRef}
              initialSecond={initalSecond}
              onCountEnd={() => setOptionAvailable(true)}
              onCountStart={() => setOptionAvailable(false)}
            />
          </b>
        </Text>
      </If>
      {optionsToRender.map((o) => (
        <OptionOTP
          key={o.value}
          active={o.value === selectedOption && optionAvailable}
          onClick={() =>
            optionAvailable ? setSelectedOption(o.value) : undefined
          }
        >
          <Image src={o.icon} alt="icon" />
          <OptionOTPText>
            <Text
              weight={
                o.value === selectedOption && optionAvailable
                  ? 'bold'
                  : 'normal'
              }
            >
              {o.text}
            </Text>
            <Text color="#858585">{o.subText}</Text>
          </OptionOTPText>
          <IconRadioSelect
            selected={o.value === selectedOption && optionAvailable}
            disabled={!optionAvailable}
          />
        </OptionOTP>
      ))}

      <Flex align="end" direction="column">
        <Button
          type="primary"
          radius="4px"
          height="40px"
          // @ts-expect-error
          mt="25px"
          width="186px"
          disabled={!optionAvailable}
          onClick={() => {
            closeModal();
            resetCountDown();
            onRequestOTP();
          }}
        >
          <b>Send Verification Code</b>
        </Button>
      </Flex>
    </ModalOptionOTP>
  );
};

export default ModalOTPOptions;
